import generateBasicEntityActions from './generateBasicEntityActions';

const usefulLinkActions = generateBasicEntityActions('usefulLinks', 'usefulLink');

export default usefulLinkActions;
